import React, { createContext, useContext, useState, useEffect } from 'react';

const UniverseThemeContext = createContext(null);

export const UniverseThemeProvider = ({ children }) => {
  const getInitialUniverse = () => {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('universe-theme');
      return savedTheme || 'portal';
    }
    return 'portal';
  };

  const getInitialElseworld = () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('elseworld-theme') || null;
    }
    return null;
  };

  const [currentUniverse, setCurrentUniverse] = useState(getInitialUniverse);
  const [currentElseworld, setCurrentElseworld] = useState(getInitialElseworld);

  const applyTheme = (universeSlug, elseworldSlug = null) => {
    if (typeof window !== 'undefined') {
      document.body.setAttribute('data-universe', universeSlug);
      if (elseworldSlug) {
        document.body.setAttribute('data-elseworld', elseworldSlug);
        localStorage.setItem('elseworld-theme', elseworldSlug);
      } else {
        document.body.removeAttribute('data-elseworld');
        localStorage.removeItem('elseworld-theme');
      }
      localStorage.setItem('universe-theme', universeSlug);
    }

    setCurrentUniverse(universeSlug);
    setCurrentElseworld(elseworldSlug);
  };

  useEffect(() => {
    const initialUniverse = getInitialUniverse();
    const initialElseworld = getInitialElseworld();
    applyTheme(initialUniverse, initialElseworld);
  }, []);

  const setUniverseTheme = (universeSlug) => {
    applyTheme(universeSlug, null);
  };

  const setElseworldTheme = (universeSlug, elseworldSlug) => {
    applyTheme(universeSlug, elseworldSlug);
  };

  const clearElseworldTheme = () => {
    applyTheme(currentUniverse, null);
  };

  const value = {
    currentUniverse,
    currentElseworld,
    setUniverseTheme,
    setElseworldTheme,
    clearElseworldTheme,
  };

  return (
    <UniverseThemeContext.Provider value={value}>
      {children}
    </UniverseThemeContext.Provider>
  );
};

export const useUniverseTheme = () => {
  const context = useContext(UniverseThemeContext);
  if (!context) {
    throw new Error('useUniverseTheme must be used within an UniverseThemeProvider');
  }
  return context;
};

export default UniverseThemeContext;
